import "./ContentNode.css";
import { useState, useEffect, useMemo } from "react";
import { ReactComponent as Cylinder } from "../../assets/svgs/Cylinder.svg";

const ContentNode = ({
  node,
  selectedNode,
  setSelectedNode,
  selectedJourney,
}) => {
  const { id, top, left, icon, type, name } = node;
  const [SvgIcon, setSvgIcon] = useState(null);

  const isSelected = useMemo(() => selectedNode?.id === id, [selectedNode, id]);

  const isHighlighted = useMemo(
    () => selectedJourney?.nodes?.some((n) => n === id),
    [selectedJourney, id]
  );

  const backgroundColor = useMemo(() => {
    if (isHighlighted) return isSelected ? "#75bcc7" : "#b6dce1";
    return isSelected ? "#CCCCCC" : "#FFFFFF";
  }, [isHighlighted, isSelected]);

  const nodeStyle = useMemo(() => {
    const baseStyle = {
      backgroundColor,
      boxShadow: isSelected ? "0px 0px 0px 1px #194F91" : "none",
      position: ["3", "4"].includes(type) ? "static" : "absolute",
      top,
      left,
      borderColor: "#194F91",
      zIndex: 2,
    };

    switch (type) {
      case "1":
        return {
          ...baseStyle,
          borderColor: "#00263E",
          boxShadow: isSelected ? "0px 0px 0px 1px #00263E" : "none",
          width: "156px",
          height: "56px",
        };
      case "2":
        return {
          ...baseStyle,
          borderColor: "#00263E",
          boxShadow: isSelected ? "0px 0px 0px 1px #00263E" : "none",
          width: "122px",
          height: "42px",
        };
      case "3":
        return { ...baseStyle, width: "auto", height: "39px" };
      case "4":
        return { ...baseStyle, width: "195px", height: "60px" };
      default:
        return baseStyle;
    }
  }, [backgroundColor, isSelected, type, top, left]);

  const textStyle = useMemo(() => {
    switch (type) {
      case "1":
        return {
          fontSize: "12px",
          color: "#00263E",
          lineHeight: "14px",
          letterSpacing: "0.25em",
        };
      case "2":
        return {
          fontSize: "11px",
          color: "#194F91",
          lineHeight: "13px",
          letterSpacing: "0.25em",
          textTransform: "uppercase",
        };
      case "3":
        return {
          fontSize: "13px",
          color: "#194F91",
          lineHeight: "16px",
          letterSpacing: "0.12em",
        };
      case "4":
        return { fontSize: "16px", color: "#194F91", lineHeight: "19px" };
      default:
        return {
          fontSize: "12px",
          color: "#194F91",
          lineHeight: "14px",
          letterSpacing: "0.25em",
        };
    }
  }, [type]);

  useEffect(() => {
    const importIcon = async () => {
      try {
        const Icon = await import(`../../assets/svgs/${icon}.svg`);
        setSvgIcon(
          () =>
            Icon.ReactComponent || (() => <img src={Icon.default} alt={icon} />)
        );
      } catch (error) {
        console.error("Error loading SVG icon:", error);
      }
    };

    if (icon) {
      importIcon();
    }
  }, []);

  return (
    <>
      {id !== "onPremiseData" ? (
        <div
          className={
            isHighlighted ? "content-node highlight-node" : "content-node"
          }
          style={nodeStyle}
          onClick={() => setSelectedNode(node)}
        >
          {SvgIcon && <SvgIcon />}
          <span style={textStyle}>{name}</span>
        </div>
      ) : (
        <div
          className={
            isHighlighted ? "on-premise-box highlight-node" : "on-premise-box"
          }
          style={{
            background: backgroundColor,
          }}
          onClick={() => setSelectedNode(node)}
        >
          {(node?.text || []).map((value) => (
            <span
              className="on-premise-text"
              key={value.id}
              style={{
                top: value.top,
                left: value.left,
                background: backgroundColor,
              }}
            >
              {value.title}
            </span>
          ))}
          <svg
            width="100%"
            height="100%"
            style={{ position: "absolute", left: "0" }}
          >
            <path
              d="M0 24 L85 24"
              stroke="#194F91"
              fill="transparent"
              strokeWidth="1"
            />
            <path
              d="M0 64 L75 64"
              stroke="#194F91"
              fill="transparent"
              strokeWidth="1"
            />
          </svg>
          <Cylinder
            style={{
              position: "absolute",
              top: "25px",
              left: "80px",
              width: "30px",
              color: "#194F91",
            }}
          />
        </div>
      )}
    </>
  );
};

export default ContentNode;
